/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_WaistInputs */

const en_us2_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halfway between the lowest rib and the top of the hip bone, usually a little above the navel. Belly relaxed, not pulled in, at the end of a breath out.`)
};

const pt_br2_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ponto médio entre a última costela e o topo do osso do quadril, em geral um pouco acima do umbigo. Barriga relaxada, sem encolher, ao fim de uma expiração.`)
};

const es_419_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mitad de camino entre la última costilla y la parte alta del hueso de la cadera, por lo general un poco arriba del ombligo. Abdomen relajado, sin meterlo, al final de una exhalación.`)
};

const pt_pt2_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A meio caminho entre a última costela e o topo do osso da anca, em geral um pouco acima do umbigo. Barriga relaxada, sem a encolher, no fim de uma expiração.`)
};

const fr_fr2_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À mi-chemin entre la dernière côte et le haut de l'os de la hanche, en général un peu au-dessus du nombril. Ventre relâché, sans le rentrer, à la fin d'une expiration.`)
};

const de_de2_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Mitte zwischen unterster Rippe und Oberkante des Beckenknochens, meist etwas über dem Bauchnabel. Bauch entspannt, nicht eingezogen, am Ende einer Ausatmung.`)
};

const it_it2_body_measures_how_waist = /** @type {(inputs: Body_Measures_How_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A metà tra l'ultima costola e la sommità dell'osso dell'anca, di solito poco sopra l'ombelico. Pancia rilassata, non in dentro, alla fine di un'espirazione.`)
};

/**
* | output |
* | --- |
* | "Halfway between the lowest rib and the top of the hip bone, usually a little above the navel. Belly relaxed, not pulled in, at the end of a breath out." |
*
* @param {Body_Measures_How_WaistInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_waist = /** @type {((inputs?: Body_Measures_How_WaistInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_WaistInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_waist(inputs)
	if (locale === "es-419") return es_419_body_measures_how_waist(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_waist(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_waist(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_waist(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_waist(inputs)
	return en_us2_body_measures_how_waist(inputs)
});
export { body_measures_how_waist as "body-measures.how_waist" }